export const draggableMascotStyles = `
  .qav-root {
    position: fixed;
    /* Sit just above the "Çevrimiçi arkadaşlar" FAB (.dso-fab, --z-sticky) — they
       share the bottom-right corner — while staying below the friends drawer
       (--z-modal) and toasts (--z-toast). */
    z-index: calc(var(--z-sticky) + 1);
    user-select: none;
    touch-action: none;
  }

  .qav-hidden {
    display: none;
  }

  .qav-drag-handle {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    cursor: grab;
  }

  .qav-drag-handle:active {
    cursor: grabbing;
  }

  .qav-indicator {
    position: absolute;
    top: 0.5rem;
    left: 50%;
    transform: translateX(-50%);
    transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);
    pointer-events: none;
  }

  .qav-indicator-visible {
    opacity: 0.8;
    transform: translateX(-50%) scale(1);
  }

  .qav-indicator-hidden {
    opacity: 0;
    transform: translateX(-50%) scale(0.95);
  }

  .qav-indicator-inner {
    position: relative;
    backdrop-filter: blur(4px);
    border-radius: 9999px;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }

  .qav-indicator-label-wrap {
    position: absolute;
    top: -2rem;
  }

  .qav-indicator-label {
    font-size: var(--fs-sm);
    font-weight: 600;
  }

  .qav-pulse-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    pointer-events: none;
    animation: qav-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }

  @keyframes qav-pulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
`;
